import Visibility from '@mui/icons-material/Visibility'
import VisibilityOff from '@mui/icons-material/VisibilityOff'
import React, { useState } from 'react'
import styled from 'styled-components'
import { Input as SutraInput } from 'sutra/components/Input/Input'

type InputProps = {
  name: string
  autoComplete?: string
  placeholder?: string
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
  value: string
  style?: React.CSSProperties
  error?: boolean
  disabled?: boolean
}

const Input: React.FC<InputProps> = ({
  name,
  autoComplete,
  placeholder,
  onChange,
  value,
  style,
  error,
  disabled,
}) => {
  return (
    <StyledInput
      $size="sm"
      $error={error}
      disabled={disabled}
      name={name}
      autoComplete={autoComplete}
      placeholder={placeholder}
      onChange={onChange}
      value={value}
      style={style}
    />
  )
}

const StyledInput = styled(SutraInput)`
  background-color: #f1f1f1;

  &:focus-within {
    background-color: #ffffff;
  }

  &::placeholder,
  & input::placeholder {
    font-style: italic;
  }
`

// antd's Input.Password showed a show/hide eye by default; keep it so users
// can check what they typed.
const InputPassword: React.FC<InputProps> = ({
  name,
  autoComplete,
  placeholder,
  onChange,
  value,
  error,
  disabled,
}) => {
  const [isVisible, setIsVisible] = useState(false)
  return (
    <StyledInput
      $size="sm"
      $error={error}
      disabled={disabled}
      type={isVisible ? 'text' : 'password'}
      name={name}
      autoComplete={autoComplete}
      placeholder={placeholder}
      onChange={onChange}
      value={value}
      suffix={
        <ToggleVisibilityButton
          type="button"
          aria-label={isVisible ? 'Hide password' : 'Show password'}
          onClick={() => setIsVisible((current) => !current)}
        >
          {isVisible ? <VisibilityOff /> : <Visibility />}
        </ToggleVisibilityButton>
      }
    />
  )
}

const ToggleVisibilityButton = styled.button`
  display: inline-flex;
  padding: 0;
  border: none;
  background: transparent;
  color: inherit;
  cursor: pointer;

  svg {
    width: 19px;
    height: 19px;
  }

  &:hover {
    color: #1890ff;
  }
`

export { Input, InputPassword }
